import newsApi from "@/api/newsApi";
import { all_news_lan, idVlsDomain_in } from "@/components/NewsMain/Default/hooks/useNewsList";
import { getSearchParam } from "@/utils";
import { isShowNews1 } from "@/utils/isShowNews1";
const lan = getSearchParam("lan") || "";
const { subdomain } = useSubdomain();
const bannersState = atom({
  resData: [],
  queryParams: {
    lan: isShowNews1().validMain
      ? all_news_lan[lan]
      : isShowNews1().isIdVls
        ? idVlsDomain_in[`${subdomain}.comfortweather.com`]
        : "EN-IN",
  },
});
const useBannersCtrl = () => {
  const [banners, setBanners] = useAtom(bannersState);
  return { resData: banners.resData, queryParams: banners.queryParams, setBanners };
};
const useBannersHook = () => {
  const { queryParams, setBanners } = useBannersCtrl();
  async function loadBannerList() {
    const res = await newsApi.queryBannerList(queryParams);
    setBanners(prev => ({ ...prev, resData: res?.data?.rows || [] }));
  }
  return { loadBannerList };
};
export { useBannersHook, useBannersCtrl };
